import { logoutModalInitialState } from "../state";

export const setShowLogoutModal = (state = logoutModalInitialState, action) => {
  state.showLogoutModal = action.payload.showLogoutModal;
};
